export const common = {
    "请求延时": "İstek Gecikmesi",
    "操作成功": "İşlem Başarılı",
    "暂无数据": "Henüz Veri Yok",
    "请输入": "Lütfen girin",
    "copyok": "Kopyalama Başarılı",
    "copyerror": "Kopyalama Başarısız",
};

export const tableList = {
    "持仓": "Pozisyon",
    "仓位": "Pozisyon",
    "跟单交易量": "Kopya İşlem Hacmi",
    "跟单总交易量": "Toplam Kopya İşlem Hacmi",
    "用户昵称": "Kullanıcı Takma Adı",
    "当前委托": "Mevcut Emirler",
    "当前计划": "Mevcut Planlar",
    "历史仓位": "Geçmiş Pozisyonlar",
    "账单": "Mali Kayıtlar",
    "全部平仓": "Tümünü Kapat",
    "全部撤单": "Tüm Emirleri İptal Et",

    "合约名称": "Kontrat Adı",
    "创建时间": "Oluşturulma Zamanı",
    "方向": "Yön",
    "杠杆": "Kaldıraç",
    "保证金": "Teminat",
    "开仓价格": "Açılış Fiyatı",
    "开仓均价": "Ortalama Açılış Fiyatı",
    "全仓风险率": "Tam Pozisyon Risk Oranı",
    "预估爆仓价": "Tahmini Tasfiye Fiyatı",
    "收益率": "Getiri Oranı",
    "平仓价格": "Kapanış Fiyatı",
    "预计强平价": "Tahmini Zorla Kapatma Fiyatı",
    "持仓数量": "Pozisyon Miktarı",
    "张": "Adet",
    "风险率": "Risk Oranı",
    "保证金率": "Teminat Oranı",
    "预计止盈价": "Tahmini Kar Alma Fiyatı",
    "预计止损价": "Tahmini Zararı Durdurma Fiyatı",
    "浮动盈亏": "Gerçekleşmemiş Kâr/Zarar",
    "平仓盈亏": "Kapanış Kâr/Zararı",
    "盈亏": "Kâr/Zarar",
    "委托数量": "Emir Miktarı",
    "委托价格": "Emir Fiyatı",
    "成交价格": "İşlem Fiyatı",
    "成交均价": "Ortalama İşlem Fiyatı",
    "止盈价": "Kar Alma Fiyatı",
    "止损价": "Zararı Durdurma Fiyatı",
    "执行价": "Kullanım Fiyatı",
    "触发条件": "Tetikleme Koşulu",
    "操作": "İşlem",
    "手续费": "İşlem Ücreti",
    "平仓类型": "Kapanış Türü",
    "类型": "Tür",
    "数量": "Miktar",

    "逐仓做多": "Ayrık Pozisyon Long",
    "逐仓做空": "Ayrık Pozisyon Short",
    "全仓做多": "Tam Pozisyon Long",
    "全仓做空": "Tam Pozisyon Short",
    "永续合约": "Sürekli Kontrat",

    "手动平仓": "Manuel Kapanış",
    "市价平仓": "Piyasa Fiyatı ile Kapanış",
    "限价平仓": "Limit Fiyat ile Kapanış",
    "止盈": "Kar Al",
    "止损": "Zararı Durdur",
    "手动撤销": "Manuel İptal",
    "自动减仓": "Otomatik Pozisyon Azaltma",
    "强制减仓": "Zorunlu Pozisyon Azaltma",
    "强制平仓": "Zorunlu Kapanış",
    "资金不足系统撤单": "Yetersiz Fon - Sistem İptali",
    "资金超限系统撤单": "Fon Limiti Aşıldı - Sistem İptali",
    "撤单": "Emri İptal Et",
    "平仓": "Pozisyonu Kapat",
    "更多": "Daha Fazla",
    "部分平仓": "Kısmi Kapanış",
    "反向开仓": "Ters Pozisyon Aç",
    "加仓": "Pozisyon Ekle",
    "一键平仓": "Tek Tıkla Kapat",
    "最新价": "Son Fiyat",
    "体验金平仓": "24 Saatte Kapat",
    "下单时间": "Emir Zamanı",
    "交易类型": "İşlem Türü",
    "委托类型": "Emir Türü",
    "成交类型": "İşlem Türü",
    "逐仓平多": "Ayrık Long Kapat",
    "逐仓开多": "Ayrık Long Aç",
    "逐仓平空": "Ayrık Short Kapat",
    "逐仓开空": "Ayrık Short Aç",
    "全仓平多": "Tam Long Kapat",
    "全仓开多": "Tam Long Aç",
    "全仓平空": "Tam Short Kapat",
    "全仓开空": "Tam Short Aç",
    "可平量为0": "Kapatılabilir Miktar 0",
    "激活价格": "Aktivasyon Fiyatı",
    "状态": "Durum",
    "未激活": "Aktif Değil",
    "已激活": "Aktif",
    "回调率": "Geri Çekilme Oranı",
    "仓位ID": "Pozisyon ID",
};
export const dialog = {
    "前往设置": "Ayarlara Git",
    "提示": "Uyarı",
    "确定": "Onayla",
    "取消": "İptal",
    "确认要全部平仓吗": "Piyasa fiyatı ile tüm pozisyonları kapatmayı ve tüm emirleri iptal etmeyi onaylıyor musunuz?",
    "确认要全部撤单吗": "Tüm emirleri iptal etmek istediğinize emin misiniz?",
    "确认要一键平仓吗": "Tek tıkla kapatmayı onaylıyor musunuz?",
    "确认要一键平仓": "Tek tıkla kapatmayı ve kopya ilişkisini sonlandırmayı onaylıyor musunuz?",
    "确认要市价平仓吗": "Piyasa fiyatı ile kapatmayı onaylıyor musunuz?",
    "确认要限价平仓吗": "Limit fiyat ile kapatmayı onaylıyor musunuz?",
    "需先设置总跟单账户": "Kopya işlemini açabilmek için önce toplam kopya hesabını ayarlamanız gerekir",
    "加仓": "Pozisyon Ekle",
    "不能为空": "Boş olamaz",
    "必须为数字值": "Sayısal bir değer olmalıdır",
    "数字不能小于等于0": "Sayı 0'dan küçük veya eşit olamaz",
    "请输入正确的杠杆倍数": "Lütfen doğru kaldıraç katını girin",
    "无法切换仓位模式": "Pozisyon modu değiştirilemiyor",
    "当前账户没有权限": "Mevcut hesabın izni yok",
    "swap001": "Mevcut pozisyonlar var, pozisyon modu değiştirilemez",
    "需全部平仓后可重新设置": "Kopya pozisyonu tutulurken kopya miktarı ve oranı değiştirilemez, tamamen kapatıldıktan sonra yeniden ayarlanabilir",
    "按张数": "Adet Bazında",
    "按金额": "Tutar Bazında",
    "按比例": "Oran Bazında",
    "按价格": "Fiyat Bazında",
    "张": "Adet",
    "预计加仓金额": "Tahmini Pozisyon Ekleme Tutarı",
    "预计加仓张数": "Tahmini Pozisyon Ekleme Adedi",
    "持仓数量": "Pozisyon Miktarı",
    "开仓价格": "Açılış Fiyatı",
    "确认要反向开仓吗": "Ters pozisyon açmayı onaylıyor musunuz?",
    "预计平仓金额": "Tahmini Kapanış Tutarı",
    "预计平仓比例": "Tahmini Kapanış Oranı",
    "预计平仓张数": "Tahmini Kapanış Adedi",
    "比例不可以大于": "Oran şundan büyük olamaz: ",
    "比例不可以小于": "Oran şundan küçük olamaz: ",
    "部分平仓": "Kısmi Kapanış",
    "确认撤单吗": "Emri iptal etmek istediğinize emin misiniz?",
    "确认要平仓吗": "Pozisyonu kapatmak istediğinize emin misiniz?",
    "盈亏": "Kâr/Zarar",
    "当前止损价": "Mevcut Zararı Durdurma Fiyatı",
    "预估止损价": "Tahmini Zararı Durdurma Fiyatı",
    "亏损": "Zarar",
    "止损修改": "Zararı Durdurma Düzenleme",
    "止损比例": "Zararı Durdurma Oranı",
    "止损价格": "Zararı Durdurma Fiyatı",
    "当前盈利价": "Mevcut Kar Fiyatı",
    "预估止盈价": "Tahmini Kar Alma Fiyatı",
    "收益": "Kazanç",
    "止盈修改": "Kar Alma Düzenleme",
    "止盈比例": "Kar Alma Oranı",
    "止盈价格": "Kar Alma Fiyatı",
    "请输入加仓数": "Lütfen pozisyon ekleme miktarını girin",
    "请输入金额": "Lütfen tutarı girin",
    "请输入止盈价格": "Lütfen kar alma fiyatını girin",
    "请输入止盈比例": "Lütfen kar alma oranını girin",
    "请输入止损价格": "Lütfen zararı durdurma fiyatını girin",
    "请输入止损比例": "Lütfen zararı durdurma oranını girin",

    "BTC/USDT账户模式": "BTC/USDT Hesap Modu",
    "账户模式": "Hesap Modu",
    "调整仓位模式": "Pozisyon Modunu Ayarla",
    "保证金模式": "Teminat Modu",
    "仓位模式": "Pozisyon Modu",
    "调整保证金模式": "Teminat modunu ayarlamak tüm USDT kontratlarında geçerlidir",
    "调整仓位合并模式": "Pozisyon birleştirme modunu ayarlamak tüm USDT kontratlarında geçerlidir",
    "全仓模式": "Tam Pozisyon Modu",
    "仓位合并": "Pozisyon Birleştirme",
    "逐仓": "Ayrık",
    "全仓": "Tam",
    "合仓": "Birleştirilmiş",
    "分仓": "Ayrılmış",
    "swap002": "Ayrık pozisyon modunda, kullanıcılar çift yönlü pozisyon alabilir, short ve long pozisyon riskleri ayrı hesaplanır. Kullanıcı tasfiye olduğunda sadece pozisyon teminatını kaybeder. Kullanıcı manuel kapanış yaptığında, short ve long pozisyonların ayrı ayrı oluşturduğu zarar ve kâr, ilgili pozisyonun teminatına anında yansıtılır.",
    "全仓模式下所有仓位将共享合约账户的可用保证金": "Tam pozisyon modunda tüm pozisyonlar kontrat hesabının kullanılabilir teminatını paylaşır, zorunlu kapanış durumunda tüm pozisyonlar ve kullanılabilir teminat kaybedilebilir. Lütfen pozisyon riskine dikkat edin!",
    "合仓提示": "",
    "分仓提示": "",
    "不再提示": "Bir daha gösterme",

    "biking合约用户使用协议": "biking Kontrat Kullanıcı Sözleşmesi",
    "综述": "<b>1. Genel Bakış</b><br><br>" + "<span>" + "1.1 Sürekli Kontratlar ('bu Hizmet'), 'biking' tarafından sunulan sanal varlık türevleridir. Ürün tasarım yönetimi ve işlem platformu operasyon hizmetlerinden 'biking' sorumludur." + "'biking' Sürekli Kontratlarını kullanmak için, 《'biking' Sürekli Kontratlar Kullanıcı Sözleşmesi》'ni ('bu Sözleşme') okumanız ve kabul etmeniz gerekir. Lütfen tüm maddeleri dikkatle okuyup tam olarak anlayın ve bu Sözleşmeyi kabul edip etmemeye karar verin." + "<br><br>" + "1.2 Bu Sözleşmenin tüm maddelerini okuyup kabul etmedikçe, 'biking' Sürekli Kontratlarını ve ilgili hizmetleri kullanma hakkınız yoktur. Bu Sözleşmeyi kabul etmeniz ve bu Hizmeti kullanmanız, okuduğunuz ve bu Sözleşmeye bağlı kalacağınız anlamına gelir." + "</span>" + "<br><br>" + "<b>2. Bu Hizmeti Kullanma Ehliyeti</b>" + "<br><br>" + "<span>2.1 Anlıyor ve onaylıyorsunuz ki:" + "<br>" + "'biking Hizmet Şartları'na uymayı kabul ettiniz ve aynı zamanda orada tanımlanan 'hizmetleri' kullanma ehliyetine sahipsiniz ve engellenmemişsiniz;" + "<br>" + "Bu Sözleşme, bulunduğunuz ülke veya bölgenin yasaları ile çelişmemektedir;" + "<br>" + "Bu hizmete yatırılan sanal varlıkların yasal sahibisiniz ve bu sanal varlıkların kaynağının yasal olduğunu garanti edersiniz." + "<br><br>" + "2.2 Bu Hizmeti kullanmanın risklerini anlıyorsunuz, bunlarla sınırlı olmamak üzere:" + "<br>" + "Sanal varlıklar ve türevlerinin yüksek fiyat oynaklığı, kısa sürede önemli veya tam kayıplara neden olabilir;" + "</span>",
    "我已阅读并同意上述协议": "Yukarıdaki sözleşmeyi okudum ve kabul ediyorum",

    "调整杠杆": "Kaldıraç Ayarla",
    "杠杆倍数": "Kaldıraç Katı",
    "当前杠杆倍数最大可开": "Mevcut kaldıraç katı ile maksimum açılabilecek: ",
    "当前仓位所需保证金：": "Mevcut pozisyon için gerekli teminat: ",

    "交易单位切换": "İşlem Birimi Değiştirme",
    "成交类型切换": "İşlem Türü Değiştirme",
    "限价": "Limit",
    "市价": "Piyasa",
    "数字范围必须在": "Sayı aralığı 1 ile 100 arasında olmalıdır",
    "请输入平仓数": "Lütfen kapanış miktarını girin",
    "请输入平仓比例": "Lütfen kapanış oranını girin",
    "请输入整数": "Lütfen tam sayı girin",
    "以当前最优价格交易": "Mevcut en iyi fiyat ile işlem yap",
    "请输入格式正确的杠杆倍数": "Lütfen doğru formatta kaldıraç katı girin",
    "杠杆倍数提示": "Mevcut kaldıraç katı yüksek, lütfen risklere dikkat edin.",
    "下单二次确认": "Emir Onayı",
    "平仓二次确认": "Kapanış Onayı",
    "下单确认": "Emir Onayı",
    "二次确认不展示": "Bir daha gösterme ('Tercih Ayarları'ndan yeniden etkinleştirebilirsiniz)",
    "切换交易单位": "İşlem Birimini Değiştir",
    "偏好设置": "Tercih Ayarları",
    "仓位止盈止损": "Pozisyon Kar Al/Zarar Durdur",
    "移动止盈止损": "Hareketli Kar Al/Zarar Durdur",
    "止盈止损提示": "Hareketli Kar Al/Zarar Durdur, pozisyon kapanışı için kullanılır. Piyasa lehte yönde ilerlerken, yatırımcının kazancını korumak amacıyla, piyasa geri çekildiğinde yatırımcının belirlediği emri piyasaya gönderen strateji emridir. Piyasanın son fiyatı belirlenen aktivasyon fiyatına ulaştığında, emir aktif hale gelir; piyasa fiyatı, yatırımcının bu stratejiyi belirledikten sonraki en yüksek (en düşük) fiyatın (1±geri çekilme oranı) değerine ulaştığında, emir tetiklenir ve işleme alınır, işlem fiyatı en yüksek (en düşük) fiyatın (1±geri çekilme oranı) olur.",
    "最新成交价": "Son İşlem Fiyatı",
    "设置止盈": "Kar Al Ayarla",
    "设置止损": "Zararı Durdur Ayarla",
    "预计盈利": "Tahmini Kâr",
    "预计亏损": "Tahmini Zarar",
    "调整保证金": "Teminatı Ayarla",
    "增加": "Arttır",
    "减少": "Azalt",
    "最大": "Maksimum",
    "当前仓位保证金": "Mevcut Pozisyon Teminatı",
    "最大可增加": "Maksimum Arttırılabilir",
    "最大可减少": "Maksimum Azaltılabilir",
    "调整后参考强评价": "Ayarlama Sonrası Referans Tasfiye Fiyatı",
    "请输入保证金": "Lütfen teminat miktarını girin",
    "强平价格": "Zorunlu Kapanış Fiyatı",
    "开仓数量": "Açılış Miktarı",
    "计算": "Hesapla",
    "计算结果": "Hesaplama sonuçları sadece referans içindir",
    "回调率": "Geri Çekilme Oranı",
    "请输入回调率": "Lütfen geri çekilme oranını girin",
    "仓位数量": "Pozisyon Miktarı",
    "激活价": "Aktivasyon Fiyatı",
    "请输入激活价": "Lütfen aktivasyon fiyatını girin",
    "激活做多提示": "Long yönü için son işlem fiyatından yüksek olmalıdır",
    "激活做空提示": "Short yönü için son işlem fiyatından düşük olmalıdır",
};
export const codeInfo = {
    "永续合约": "Sürekli",
    "标记价格": "İşaret Fiyatı",
    "指数价格": "Endeks Fiyatı",
    "指数价格提示": "Bu kontratın gerçek zamanlı endeks fiyatı. Bu fiyat, kullanıcı pozisyonlarının tahmini tasfiye fiyatı hesaplamasına katılır ve fiyat manipülasyonundan kaçınmak için kontratın son işlem fiyatından sapabilir.",
    "24H最高": "24s En Yüksek",
    "24H最低": "24s En Düşük",
    "资金费率": "Mevcut Dönem Fon Oranı",
    "距费用结算": "Mevcut dönem ücret ödemesine kalan süre",
    "我的赠金": "Bonusum",
};
export const panKou = {
    "交易深度": "Derinlik",
    "实时成交": "Alım-Satım",
    "张": "Adet",
    "保证金": "Teminat",
    "价格": "Fiyat",
    "数量": "Miktar",
    "时间": "Zaman",
    "累计": "Toplam",
};
export const placeOrder = {
    "立即去玩": "Hemen Oyna",
    "全仓": "Tam",
    "逐仓": "Ayrık",
    "杠杆": "Kaldıraç",
    "开多": "Long Aç",
    "开空": "Short Aç",
    "市价委托": "Piyasa",
    "限价委托": "Limit",
    "计划委托": "Plan",
    "价格": "Fiyat",
    "数量": "Miktar",
    "限价": "Limit",
    "市价": "Piyasa",
    "止盈止损": "Kar Al/Zarar Durdur",
    "张": "Adet",
    "开仓价": "Açılış Fiyatı",
    "触发价": "Tetikleme Fiyatı",
    "执行价": "Kullanım Fiyatı",

    "收益": "Kazanç",
    "按比例设置": "Orana Göre Ayarla",
    "按价格设置": "Fiyata Göre Ayarla",
    "亏损": "Zarar",

    "swap003": "Al/Long",
    "swap004": "Sat/Short",
    "买入": "Al",
    "卖出": "Sat",
    "做多": "Long",
    "做空": "Short",
    "可用": "Kullanılabilir",
    "可做多": "Long Açılabilir",
    "可做空": "Short Açılabilir",

    "资产": "Varlık",
    "持仓保证金": "Pozisyon Teminatı",
    "未实现盈亏": "Gerçekleşmemiş Kâr/Zarar",
    "净值": "Net Değer",
    "可用保证金": "Kullanılabilir Teminat",
    "账户余额": "Hesap Bakiyesi",
    "风险率": "Risk Oranı",

    "合约信息": "Kontrat Bilgisi",
    "指数来源": "Endeks Kaynağı",
    "合约面值": "Kontrat Nominal Değeri",
    "资金费率": "Fon Oranı",
    "最大杠杆": "Maksimum Kaldıraç",
    "下单方向可开张数的": "Emir yönünde açılabilecek adet sayısının",

    "立即注册": "Kaydol",
    "登录": "Giriş Yap",
    "swap005": "Varlık (Sürekli Kontrat)",
    "登录以查看": "Görüntülemek için giriş yapın",

    "请输入数量": "Lütfen miktarı girin",
    "请输入价格": "Lütfen fiyatı girin",
    "请输入限价": "Lütfen limit fiyatı girin",
    "请输入止盈止损": "Lütfen kar alma/zarar durdurma değerlerini girin",
    "止损率不能大于90%": "Zararı durdurma oranı %90'dan büyük olamaz",
    "止损价格不能大于": "Zararı durdurma fiyatı şundan büyük olamaz: ",
    "开通合约账号": "Kontrat Hesabı Aç",
    "账号冻结": "Hesap Donduruldu",
    "止盈率不能大于1000%": "Kar alma oranı %1000'den büyük olamaz",
    "请输入触发价": "Lütfen tetikleme fiyatını girin",
    "保证金": "Teminat",
    "体验金": "Deneme Parası",
    "不使用体验金": "Deneme Parası Kullanma",
    "查看详情": "Detayları Görüntüle",
    "委托保证金": "Emir Teminatı",
    "币": "Coin",
    "计算器": "Hesap Makinesi",
    "划转": "Transfer"
};
export const codelist = {
    "搜索": "Ara",
    "全部": "Tümü",
    "交易对": "İşlem Çifti",
    "最新价": "Son Fiyat",
    "涨幅": "Değişim",
    "自选": "Favoriler",
    "添加自选成功": "Favorilere Eklendi",
    "取消自选成功": "Favorilerden Kaldırıldı",
};
export const merchandiser = {
    "我的实盘": "Gerçek Hesabım",
    "与优秀的交易员共同赚钱": "Mükemmel trader'larla birlikte para kazanın",
    "code_00051": "Kopya Topluluğu",
    "个人中心": "Profil",
    "更多服务": "Daha Fazla Hizmet",
    "钱包": "Cüzdan",
    "衍生品": "Türevler",
    "跟单设置": "Kopya Ayarları",
    "跟单": "Kopya",
    "跟单提示": "Veriler saatte bir güncellenir",
    "我的跟单": "Kopyalarım",
    "成为交易员": "Trader Ol",
    "综合排名": "Genel Sıralama",
    "收益率": "Getiri Oranı",
    "近3周收益": "Son 3 Hafta Getirisi",
    "近3周胜率": "Son 3 Hafta Başarı Oranı",
    "总收益": "Toplam Getiri",
    "累计收益率": "Kümülatif Getiri Oranı",
    "累计跟随人数": "Toplam Takipçi Sayısı",
    "跟随中": "Takip Ediliyor",
    "AUM": "Yönetilen Varlık (AUM)",
    "当前跟谁": "Şu Anda Kim Takip Ediliyor",
    "搜索交易员": "Trader Ara",
    "满员": "Dolu",
    "申请成为交易员": "Trader Olarak Başvur",
    "手机号": "Telefon Numarası",
    "邮箱": "E-posta",
    "请输入邮箱": "Lütfen e-posta adresini girin",
    "邮箱错误": "Lütfen geçerli bir e-posta adresi girin",
    "请输入手机号": "Lütfen telefon numarasını girin",
    "手机号错误": "Lütfen geçerli bir telefon numarası girin",
    "请输入正确数值": "Lütfen doğru tutarı girin",
    "申请交易员提示文案": "Trader olarak başvurun ve işlem kârı payı kazanın",
    "跟单确认": "Kopya Onayı",
    "我已同意跟单协议": "Kopya sözleşmesini okudum ve kabul ediyorum",
    "跟单协议": "《Kopya Sözleşmesi》",
    "申请跟单提示文案": "Bu sözleşme sizin (bundan böyle 'Siz' veya 'Sizin' olarak anılacaktır) ve Biking arasında yapılır. Biking platformunu veya altındaki herhangi bir web sitesini (wang.com), mobil uygulamaları aracılığıyla sunulan herhangi bir hizmeti veya aşağıda 4. maddede daha ayrıntılı açıklanan, Biking veya altındaki herhangi bir iştirakinin web siteleri aracılığıyla sunulan diğer ilgili hizmetleri (bundan böyle topluca 'Bu Hizmetler' olarak anılacaktır) ziyaret etmeniz veya kullanmanız, platformumuzda yayınlanan Gizlilik Bildirimi de dahil olmak üzere, bu Kullanım Şartları Sözleşmesi'nde (bundan böyle 'Bu Kullanım Şartları' olarak anılacaktır) belirtilen tüm şart ve koşulları okuduğunuzu, anladığınızı ve kabul ettiğinizi teyit ettiğiniz anlamına gelir. Ayrıca, Bu Hizmetlerin bazı işlevlerini kullanırken, bu işlevler için geçerli olan ek şart ve koşullara da uymanız gerekebilir.",
    "申请跟单提示文案1": "1. Bir trader'ı takip ederek pozisyon açmak, kayıp riski taşıyabilir. Bu risk kopya kullanıcısı tarafından üstlenilir;",
    "申请跟单提示文案2": "2. Biking platformu, takipçilerin ayrık pozisyon modundaki kopya hesaplarını kullanarak kopya işlemi yapmalarını destekler. Takipçiler bağımsız pozisyon açmak isterse, kontrat işlemleri için kontrat hesabını kullanabilir, bu süre zarfında kopya hesabı etkilenmez.",
    "申请跟单提示文案3": "3. Takip başarılı olduktan sonra, sadece trader'ın yeni açtığı pozisyonlar takip edilir, halihazırda bulunan pozisyonlar takip edilmez; istediğiniz zaman takibi iptal edebilirsiniz, takibi iptal etmek halihazırda takip edilen emirleri kapatmaz, manuel olarak kapatmayı seçebilirsiniz;",
    "申请跟单提示文案4": "4. Takip sırasında, kopya pozisyonunda ayarlama yapmak sizi kopya modundan çıkarır;",
    "申请跟单提示文案5": "5. Takip edilen trader pozisyonu kapattığında kâr elde edilirse, bu emirden trader ödülü olarak kârın %12'si ayrılır.",
    "申请跟单提示文案6": "6. Bir trader'ı takip ederek emir vermek, kayıp riski taşıyabilir, lütfen dikkatli seçim yapın, risk kontrolüne dikkat edin ve kopya risklerini anlayın",
    "申请跟单提示文案7": "7. Takip ettiğiniz trader'ın emri kural ihlali olarak değerlendirilip trader statüsü iptal edildiğinde, yeni pozisyon açmak için takip edemezsiniz, halihazırda takip edilen pozisyonlar etkilenmez ancak hemen kopya modundan çıkar.",
    "申请跟单提示文案8": "8. Trader'lar takipçileri kaldırma hakkına sahiptir, kaldırıldığınızda yeni pozisyon açmak için takip edemezsiniz, halihazırda takip edilen pozisyonlar etkilenmez.",
    "搜索您的国家名或国家区号": "Ülke adınızı veya ülke kodunuzu arayın",
    "我已同意成为交易员": "Trader olmayı kabul ediyorum",
    "请勾选": "Lütfen işaretleyin",
    "申请交易员失败提示": "Şu anda kopya işlemindesiniz, şimdilik trader olarak başvuramazsınız, lütfen tüm kopyaları durdurun ve ardından başvurun.",
    "我知道了": "Anladım",
    "今日收益": "Günlük Getiri",
    "累计收益": "Toplam Getiri",
    "交易员分成": "Trader Payı",
    "待结算分成": "Ödenecek Pay",
    "已结算分成": "Ödenmiş Pay",
    "当前跟单": "Mevcut Kopyalar",
    "历史跟单": "Geçmiş Kopyalar",
    "我的交易员": "Trader'larım",
    "编辑": "Düzenle",
    "平仓均价": "Ortalama Kapanış Fiyatı",
    "持仓均价": "Ortalama Pozisyon Fiyatı",
    "开仓时间": "Açılış Zamanı",
    "平仓时间": "Kapanış Zamanı",
    "预估暴仓价": "Tahmini Tasfiye Fiyatı",
    "交易员": "Trader",
    "详情": "Detaylar",
    "仓位ID": "Pozisyon ID",
    "空位提醒": "Boş Yer Bildirimi",
    "空位提醒内容": "Bu trader'ın takipçi kapasitesi doldu, trader kapasitesi doluluk durumu değiştiğinde bir kez bildirim gönderilecek",
    "当前跟随": "Şu Anda Takip Edilen",
    "跟随人数数据": "{v1}/{v2} kişi",
    "跟随人数": "Takipçi Sayısı",
    "总权益": "Toplam Özkaynak",
    "带单合约": "İşlem Yapılan Kontratlar",
    "交易数据": "İşlem Verileri",
    "交易笔数": "İşlem Sayısı",
    "盈利笔数": "Kârlı İşlem Sayısı",
    "亏损笔数": "Zararlı İşlem Sayısı",
    "扛单比例": "Zarara Katlanma Oranı",
    "平均扛单率": "Ortalama Zarara Katlanma Oranı",
    "最大扛单率": "Maksimum Zarara Katlanma Oranı",
    "订单": "Emir",
    "跟随者": "Takipçi",
    "跟随者收益": "Takipçi Getirisi",
    "跟随用户": "Takip Edilen Kullanıcı",
    "跟随总额": "Toplam Takip Tutarı",
    "跟随收益": "Takip Getirisi",
    "交易员订单本金": "Trader Emir Anaparası",
    "当前带单": "Mevcut İşlemler",
    "历史带单": "Geçmiş İşlemler",
    "跟单数据统计": "Kopya Veri İstatistikleri",
    "不用了": "Hayır, Teşekkürler",
    "设置提醒成功": "Bildirim Ayarı Başarılı",
    "我的带单": "İşlemlerim",
    "查看主页": "Profili Görüntüle",
    "利润分成比例": "Kâr Paylaşım Oranı",
    "跟随交易员": "Trader'ı Takip Et",
    "仓位类型": "Pozisyon Türü",
    "指定杠杆": "Belirli Kaldıraç",
    "请输入杠杆": "Lütfen kaldıraç girin",
    "单笔倍率": "Tek İşlem Çarpanı",
    "单笔金额": "Tek İşlem Tutarı",
    "固定额度": "Sabit Limit",
    "请输入单笔金额1": "Lütfen 5U'dan az olmayan sabit bir tutar girin",
    "请输入单笔金额": "Lütfen {v1}～{v2} arası tek işlem tutarını girin",
    "请输入单笔倍率": "Lütfen {v1}～{v2} arası kopya oranını girin",
    "每次下单折合U": "Her açılışta {v1} USDT değerinde teminat kullanılır",
    "每次下单倍数": "Her emir miktarı, trader'ın emir miktarının {v1} katıdır",
    "倍率": "Çarpan",
    "跟单本金": "Kopya Anaparası",
    "总跟单保证金": "Toplam Kopya Teminatı",
    "请输入跟单本金": "Lütfen kopya anaparasını girin",
    "资产账户": "Varlık Hesabı {v1} USDT",
    "合约账户": "Kontrat Hesabı {v1} USDT",
    "风险控制": "Risk Kontrolü",
    "设置": "Ayarla",
    "保存": "Kaydet",
    "取消跟随": "Takibi İptal Et",
    "移除跟随": "Takibi Kaldır",
    "交易员保证金": "Trader Teminatı",
    "请输入交易员保证金": "Lütfen trader teminatını girin",
    "风险设置提示": "Bu trader'ı takip eden pozisyon anaparası bu değere ulaştığında, artık yeni emirler takip edilmeyecek",
    "关闭带单": "İşlemi Kapat",
    "我的跟随者": "Takipçilerim",
    "带单设置": "İşlem Ayarları",
    "预计利润分成": "Tahmini Kâr Payı",
    "利润分成": "Kâr Payı",
    "开启成功": "Açma Başarılı",
    "开启失败": "Açma Başarısız",
    "关闭成功": "Kapatma Başarılı",
    "关闭失败": "Kapatma Başarısız",
    "确认取消吗": "Takibi iptal etmek istediğinize emin misiniz?",
    "条件一": "Kontratlarda pozisyon, mevcut emir, planlı emir bulunmamalı",
    "条件二": "Kontrat hesabı kullanılabilir bakiyesi >={v} USDT olmalı",
    "条件三": "Kontratlarda pozisyon bulunmamalı",
    "最大回撤": "Maksimum Geri Çekilme",
    "平均持仓时间": "Ortalama Pozisyon Tutma Süresi",
    "正在跟随": "Takip Ediliyor",
    "历史跟随": "Geçmiş Takip",
    "累计跟单": "Toplam Kopya",
    "累计分成": "Toplam Pay",
    "笔": "işlem",
    "上一页": "Önceki Sayfa",
    "下一页": "Sonraki Sayfa",
    "返回": "Geri",
    "今日预估收益": "Günlük Tahmini Getiri",
    "账户权益": "Hesap Özkaynağı",
    "将账户权益展示在个人信息页面": "Hesap özkaynağını profil sayfasında göster",
    "带单本金": "İşlem Anaparası",
    "每次开仓均会展示带单本金": "Her açılışta işlem anaparası gösterilecek",
    "隐藏挂单价": "Limit Emir Fiyatını Gizle",
    "带单币对": "İşlem Yapılan Pariteler",
    "入住时间": "Katılma Zamanı",
    "保存成功": "Kaydetme Başarılı",
    "取消成功": "İptal Başarılı",
    "设置成功": "Ayar Başarılı",
    "跟单合约": "Kopya Kontratları",
    "历史委托": "Geçmiş Emirler",
    "成交数量": "İşlem Miktarı",
    "触发时间": "Tetikleme Zamanı",
    "开启带单": "İşlemi Aç",
    "账户已冻结": "Hesap donduruldu, lütfen müşteri hizmetleriyle iletişime geçin",
    "审核中": "İnceleniyor",
    "小时": "{v} saat",
    "累计分润": "Toplam Kâr Payı",
    "今日预估分润": "Günlük Tahmini Kâr Payı",
    "交易协议": "《İşlem Sözleşmesi》",
    "带单协议": "《İşlem Sözleşmesi》",
    "追加跟单本金": "Kopya Anaparasını Arttır",
    "提示": "Uyarı:",
    "提示信息": "Kâr payı her gün 00:00'da hesaplanmaya başlar ve 01:00'dan önce tamamlanır, hesaplandıktan sonra otomatik olarak kontrat hesabınıza aktarılır; hesaplama sırasında açık işlem pozisyonunuz varsa, kâr payı bir sonraki işlem gününde hesaplanacaktır",
    "合约跟单": "Kontrat Kopyası",
    "跟单文字": "Biking'de, dünyanın en iyi trader'larıyla birlikte para kazanın",
    "查看牛人实盘": "Usta Trader Gerçek Hesaplarını Görüntüle",
    "捕捉市场信号": "Piyasa Sinyallerini Yakala",
    "复制高手收益": "Ustaların Getirisini Kopyala",
    "跟单指南": "Kopya Kılavuzu",
    "跟单广场": "Kopya Meydanı",
    "跟单总收益": "Toplam Kopya Getirisi",
    "丰厚分润收入": "Zengin Kâr Payı Geliri",
    "更多平台曝光": "Daha Fazla Platform Görünürlüğü",
    "专属交易徽章": "Özel İşlem Rozeti",
    "成为Biking带单交易员": "Sadece bir adımda, Biking Trader'ı olun",
    "享受Biking带单交易员的独家福利": "Biking Trader'larının özel avantajlarının keyfini çıkarın",
    "平台奖励": "%12 İşlem Kâr Payı Kazanın",
    "联系方式": "İletişim Bilgileri",
    "简介": "Tanıtım",
    "请输入简介": "Lütfen tanıtım girin",
    "交易能力证明": "İşlem Yeteneği Kanıtı (opsiyonel)",
    "选择周期": "Lütfen >30 günlük getiri eğrisi, işlem veri istatistikleri gibi ekran görüntüleri seçin; yüklenmezse, Biking işlem geçmişinizi inceleyeceğiz. En fazla 3 resim yüklenebilir, her biri 10 MB'tan büyük olmamalıdır.",
    "我已阅读并同意": "Okudum ve kabul ediyorum",
    "跟单交易服务条款": "《Kopya İşlem Hizmet Şartları》",
    "立即申请": "Hemen Başvur",
    "请输入联系方式": "Lütfen iletişim bilgilerini girin",
    "联系方式不正确": "İletişim bilgileri hatalı!",
    "邮箱格式不正确": "E-posta formatı hatalı",
    "请输入简介信息": "Lütfen tanıtım bilgisi girin",
    "请确认勾选协议": "Lütfen sözleşmeyi onaylayın",
    "上传头像图片限制": "Profil resmi boyutu 10MB'ı aşamaz!",
    "最大限制": "Şu anda en fazla 3 dosya yüklenebilir",
    "带单交易员招募中": "Trader alımı devam ediyor, hemen %12 işlem kâr payının keyfini çıkarın",
    "跟单成功": "Kopya Başarılı",
    "昵称": "Takma Ad",
    "请输入昵称": "Lütfen takma ad girin",
    "申请交易员已提交": "Trader başvurusu gönderildi, lütfen inceleme sonucunu bekleyin"
};
export const hyy = {
    "bkt": "Açma",
    "wqdkt": "Açmak istediğime eminim",
    "kt12": "1. Katılmadan önce, dijital para kontrat işlemlerinin temel bilgilerini ve ilgili riskleri ile türev işlemleriyle ilgili iş kurallarını ayrıntılı olarak anlamalısınız.",
    "kt13": "2. Bu risk bildirimi, dijital varlık türev işlemleriyle ilgili tüm risk faktörlerini kapsamlı bir şekilde listelememektedir, yatırımcılar dijital varlık türev işlemlerine katılmadan önce diğer olası risk faktörlerini anlamalı ve öğrenmelidir.",
    "kt14": "3. Yatırımcılara, risk toleransları ve kendi gerçek durumlarından yola çıkarak, bu kontrat işlemlerine katılıp katılmamaya dikkatle karar vermelerini ve dijital varlıklarını makul bir şekilde yapılandırmalarını içtenlikle tavsiye ediyor ve umuyoruz.",
    "kt0": "Sevgili Kullanıcı:",
    "kt1": "Henüz bir kontrat hesabı ve kontrat işlem izniniz yok, lütfen aşağıdaki içeriği dikkatlice okuduktan sonra açıp açmamaya karar verin:",
    "kt2": "1. Kontrat piyasasında işlem yaparken, piyasa fiyat hareketleri sizin aleyhinize gelişirse ve pozisyon teminatınız yetersiz kalırsa, BiKing Sürekli Kontratlar, sistem anlaşmasına göre pozisyonunuzu zorla kapatacak ve tasfiye detaylarını açıklayacaktır.",
    "kt3": "2. BiKing Sürekli Kontratlar'ın iş kurallarını dikkatle okumalı ve bunlara uymalı, kontratların mekanizmasını ve işleyiş prensibini anlamalı, piyasanın çeşitli risklerini öğrenmelisiniz.",
    "kt4": "4. BiKing Sürekli Kontratlar, kontrat işlem sistemine bağlıdır, kullanıcı pozisyonlarının kâr/zararı kontrat piyasa hareketleriyle değişir, kayıplar büyük olduğunda, kontrat işlem sisteminde de tasfiye meydana gelebilir. Lütfen kullanıcılar, kontrat piyasa koşullarına göre kendi işlem davranışlarını zamanında kendileri belirlesinler, kâr/zarar kendilerine aittir, buna göre BiKing herhangi bir varsayılan veya belirlenmiş garanti sorumluluğu üstlenmez.",
    "kt5": "5. Bazı aşırı piyasa koşullarında, elinizdeki açık pozisyonları kapatmakta zorlanabilir veya kapatamayabilirsiniz. Örneğin, kârınız tüm kontrat piyasasındaki efektif kaldıraç PnL'sinde birinci sırada olduğunda ve karşı tarafın sigorta fonu, zararını karşılamaya yetmediği durumlarda.",
    "kt6": "6. Dijital varlık türev işlemleri, belirli yargı bölgelerinde politika düzenleme riskleriyle karşılaşabilir, işlem yapmadan önce işlem bölgesinin politika düzenleme geçmişini anlayarak dikkatli bir şekilde karar vermelisiniz. İlgili ülke ve bölgelerin yasaları, yönetmelikleri, politikalarındaki değişiklikler, kontrat borsası işlem kurallarındaki değişiklikler, acil önlemlerin çıkarılması vb. nedenlerle BiKing önceden açıklama yapacaktır, elinizdeki açık pozisyonları tutamayabilirsiniz, ancak teminat ve kâr bakiyeleri yine de ödenecektir.",
    "kt7": "7. Platform tarafının kontrolü dışındaki nedenlerle, örneğin: deprem, sel, yangın gibi mücbir sebep halleri veya bilgisayar sistemi, iletişim sistemi arızaları vb., emirlerinizin işleme alınamamasına veya tamamen işleme alınamamasına neden olabilir, bu nedenle oluşan kayıplar kendiniz tarafından üstlenilebilir.",
    "kt8": "8. 'Riskten korunma' işlemleri de spekülatif işlemler gibi, fiyat dalgalanmalarından kaynaklanan risklerle karşı karşıyadır.",
    "kta9": "9. Kimlik doğrulaması yapmadıysanız veya Google Doğrulamayı bağlamadıysanız veya hesabınızı kendiniz dışında biri tarafından kullanıma verdyseniz, kontrat teminatınızın güvenliği etkilenebilir.",
    "kta10": "3. Bazı aşırı piyasa koşullarında, elinizdeki açık pozisyonları kapatmakta zorlanabilir veya kapatamayabilirsiniz. Örneğin, kârınız tüm kontrat piyasasındaki efektif kaldıraç PnL'sinde birinci sırada olduğunda ve karşı tarafın sigorta fonu, zararını karşılamaya yetmediği durumlarda.",
    "kt9": "Dikkatle okudum ve riski üstlenmeyi kabul ediyorum",
    "kt10": "Kontrat hesabı ve kontrat işlem iznini aç",
    "zjhz": "Fon Transferi",
    "ljhz": "Hemen Transfer Et",
    "qx": "Transferi İptal Et",
    "khz": "Transfer Edilebilir",
    "qxz": "Lütfen seçin",
    "bz": "Coin",
    "c": "Kimden",
    "zz": "Kime",
    "sl": "Miktar",
    "qb": "Tümü",
    "ktcg": "Açma Başarılı",
    "ktsb": "Açma Başarısız",
    "hzcg": "Transfer Başarılı",
    "hzsb": "Transfer Başarısız",
    "wyyd": "", //Okundu onay kutusu işaretlenmemiş uyarı metni
    "tc": "Çıkış",
    "warning1": "Lütfen bir coin seçin",
    "warning2": "Gönderen hesap boş olamaz",
    "warning3": "Alıcı hesap boş olamaz",
    "warning4": "Lütfen transfer edilebilir miktarı aşmayan bir sayı girin",
    "gb": "Kapat",
    "openSuccess": "Kontrat işlemleri açıldı",
    "openSuccessTip": "Lütfen kontrat hesabına fon transfer edin",
    "warning5": "Maksimum 4 ondalık basamak",
    "not_get_nm": "Üzgünüz, deneme parası etkinliği sona erdi, bu transferde deneme parası alamadınız.",
}

export const invite = {
    "yqfy": "Davet Komisyonu",
    "yj1": "Davet bağlantısını, davet posteri veya referans kodunu paylaşın",
    "yj2": "Arkadaşlarınızı kaydolmaya ve işlem yapmaya davet edin",
    "yj3": "İşlem ücreti komisyonunun keyfini çıkarın",
    "yqm": "Davet Kodum:",
    "yqlj": "Davet Bağlantım:",
    "fz": "Kopyala",
    "fzcg": "Kopyalama Başarılı",
    "fzsb": "Kopyalama Başarısız",
    "dlck": "Görüntülemek için giriş yapın",
    "rs": "Davet Edilen Kişi Sayısı",
    "ljbb": "Toplam Spot İşlem Komisyonu({flag})",
    "ljeft": "Toplam ETF İşlem Komisyonu({flag})",
    "ljhy": "Toplam Kontrat İşlem Komisyonu({flag})",
    "yhm": "Kullanıcı Adı",
    "sfsm": "Kimlik Doğrulandı mı",
    "tjsj": "Tavsiye Zamanı",
    "zsy": "Toplam Gelir({flag})",
    "s": "Evet",
    "f": "Hayır",
    "djjz": "Daha fazla yüklemek için tıklayın",
    "ckmx": "Detayları Görüntüle",
    "pm": "Sıralama",
    "zyqr": "Aylık Davet Sayısı",
    "zfyj": "Aylık Komisyon Tutarı({flag})",
    "ckbd": "Tam Listeyi Görüntüle",
    "rlues1": "Arkadaşlarınızı davet edin, uzun vadeli komisyon kazanın, gelirinizin keyfini çıkarın.",
    "rlues2": "Arkadaşlarınızı kaydolmaya davet ederek bir davet ilişkisi kurabilirsiniz, arkadaşlarınız spot, kaldıraçlı, ETF işlemleri yaptığında onların işlem ücretlerinden komisyon kazanırsınız, davet komisyonu gelirinizin üst sınırı yoktur.",
    "rlues3": "Davet Komisyon Kuralları & Oranları",
    "jylx": "İşlem Türü",
    "yqrfy": "Davet Eden Komisyonu",
    "yqgxyxq": "Davet İlişkisi Geçerlilik Süresi",
    "sixMonth": "6 Ay",
    "yj": "Kalıcı",
    "bbjy": "Spot İşlem",
    "hyjy": "Kontrat İşlem",
    "etfjy": "Kaldıraçlı ETF İşlem",
    "gxsj": "Veriler her Pazartesi güncellenir",
    "xts": "İpuçları",
    "ts1": "Arkadaşınız kayıt olurken sizin davet kodunuzu girmelidir, böylece başarılı davetiniz sayılır!",
    "ts2": "Soldaki QR kodu telefonunuzla tarayarak kullanıcılara hızlı bir şekilde bağlantıyı iletebilirsiniz.",
    "tgzsy": "Toplam Promosyon Geliri({flag})",
    "cz": "İşlem",
    "fymx": "Komisyon Detayları >",
    "zwsj": "Henüz kayıt yok",
    "yh": "Kullanıcı",
    "hqyj": "Davet Komisyonu Kazanıldı",
    "ysm": "Kimlik Doğrulandı",
    "wsm": "Kimlik Doğrulanmadı",
    "hyfymx": "Arkadaş Komisyon Detayları",
    "fylx": "Komisyon Türü",
    "fyje": "Komisyon Tutarı",
    "fysj": "Komisyon Zamanı",
    "mxsyb": "Detaylı Gelir Tablosu",
    "zwjy": "Bu arkadaş henüz işlem yapmadı, işlem ücreti komisyonu yok",
    "bczxc": "Galeriye Kaydet",
    "rlues4": "Ağ dalgalanmalarından etkilenen bazı kullanıcılarda komisyonun gecikmeli hesaba geçmesi durumu olabilir, lütfen sabırla bekleyin.",
    "moreRules": "Detaylı kuralları görüntüle",
};


// WEBPACK FOOTER //
// ./src/i18n/lang/merchandiser/tr.js